/* eslint-disable */
const state = {
  mainDealer: null,
  gudang: null,
  karesidenan: null,
  city: null,
  dealer: null,
  category: null,
  segment: null,
  subSeries: null,
  type: null,
  codeMarket: null,
  month: null,
  year: null,
  color: null,
  transporter: null
}

const getters = {
  //Main Dealer
  getMainDealer : (state) => {
    return state.mainDealer
  },

  //Gudang
  getGudang : (state) => (mainDealer) => {
    if(mainDealer == null || mainDealer.length == 0) return state.gudang
    let mainDealers = mainDealer.map(a => a.code);
    return state.gudang.filter((singleGudang) => { return mainDealers.indexOf(singleGudang.mainDealerCode) !== -1 })
  },
  getGudangBySingleId : (state) => (mainDealer) => {
    if(mainDealer == null || mainDealer == '') return state.gudang
    return state.gudang.filter(singleGudang => singleGudang.mainDealerCode == mainDealer)
  },

  //Karesidenan
  getKaresidenan : (state) => {
    return state.karesidenan
  },
  getKaresidenanByMainDealer : (state) => (mainDealer) => {
    if(mainDealer == null || mainDealer == '') return state.karesidenan
    // console.log(state.karesidenan , mainDealer)
    return state.karesidenan.filter(singleKaresidenan => singleKaresidenan.maindealer == mainDealer)
  },

  //City
  getCity : (state) => (karesidenan) => {
    if(karesidenan == null || karesidenan.length == 0) return state.city
    let karesidenans = karesidenan.map(a => a.code);
    return state.city.filter((singleCity) => { return karesidenans.indexOf(singleCity.karesidenan) !== -1 })
  },
  getCityBySingleId : (state) => (karesidenan) => {
    if(karesidenan == null || karesidenan == '') return state.city
    return state.city.filter(singleCity => singleCity.karesidenan == karesidenan)
  },

  //Dealer
  getDealer : (state) => (karesidenan, city) => {
    if(
      (karesidenan == null || karesidenan.length == 0) &&
      (city == null || city.length == 0)
    ) return state.dealer

    var counter = 0;
    var karesidenans = []
    var cities = []
    var compiledStr = "state.dealer.filter((singleDealer) => { return "

    if (karesidenan != null && karesidenan.length > 0){
      karesidenans = karesidenan.map(a => a.code)
      compiledStr += "karesidenans.indexOf(singleDealer.karesidenan) !== -1 &&"
      counter++;
    }

    if(city != null && city.length > 0){
      cities = city.map(a => a.code)
      compiledStr += "cities.indexOf(singleDealer.city) !== -1 &&"
      counter++;
    }

    if(counter != 0) compiledStr = compiledStr.slice(0, compiledStr.length-3) + " })";

    return eval(compiledStr)
  },
  getDealerBySingleId : (state) => (karesidenan, city) => {
    if(
      (karesidenan == null || karesidenan == '') &&
      (city == null || city == '')
    ) return state.dealer

    var counter = 0;
    var compiledStr = "state.dealer.filter(singleDealer => "

    if (karesidenan != null && karesidenan != ''){
      compiledStr += "singleDealer.karesidenan == karesidenan &&"
      counter++;
    }

    if (city != null && city != ''){
      compiledStr += "singleDealer.city == city &&"
      counter++;
    }

    if(counter != 0) compiledStr = compiledStr.slice(0, compiledStr.length-3) + " )";

    return eval(compiledStr);
  },

  //Category
  getCategory : (state) => {
    return state.category
  },
  getSimpleCategory : (state) => {
    return state.category
  },

  //Segment
  getSegment : (state) => (category) => {
    if(category == null || category.length == 0) return state.segment
    let categories = category.map(a => a.category);
    return state.segment.filter((singleSegment) => { return categories.indexOf(singleSegment.category) !== -1 })
  },
  getSimpleSegment : (state) => (category) => {
    if(category == null || category.length == 0) return state.segment
    let categories = typeof category == 'string' ? [category] : category;
    return state.segment.filter((singleSegment) => { return categories.indexOf(singleSegment.category) !== -1 })
  },
  getSegmentBySingleId : (state) => (category) => {
    if(category == null || category == '') return state.city
    return state.segment.filter(singleSegment => singleSegment.category == category)
  },

  //Sub Series
  getSubSeries : (state) => (category, segment) => {
    if(
      (category == null || category.length == 0) &&
      (segment == null || segment.length == 0)
    ) return state.subSeries

    var counter = 0;
    var categories = []
    var segments = []
    var compiledStr = "state.subSeries.filter((singleSubSeries) => { return "

    if (category != null && category.length > 0){
      categories = category.map(a => a.category)
      compiledStr += "categories.indexOf(singleSubSeries.category) !== -1 &&"
      counter++;
    }

    if(segment != null && segment.length > 0){
      segments = segment.map(a => a.segment)
      compiledStr += "segments.indexOf(singleSubSeries.segment) !== -1 &&"
      counter++;
    }

    if(counter != 0) compiledStr = compiledStr.slice(0, compiledStr.length-3) + " })";

    return eval(compiledStr)
  },
  getSimpleSubSeries : (state) => (category, segment) => {
    if(
      (category == null || (typeof category != 'string' && category.length == 0)) &&
      (segment == null || (typeof segment != 'string' && segment.length == 0))
    ) return state.subSeries

    var categories = []
    var segments = []
    var compiledStr = ""

    //Array of 'category' strings or a string of 'category'
    if(category != null && (typeof category == 'string' || category.length > 0)){
      categories = typeof category == 'string' ? [category] : category
      compiledStr += "categories.indexOf(x.category) !== -1 &&"
    }

    //Array of 'segment' strings or a string of 'segment'
    if(segment != null && (typeof segment == 'string' || segment.length > 0)){
      segments = typeof segment == 'string' ? [segment] : segment
      compiledStr += "segments.indexOf(x.segment) !== -1 &&"
    }

    if(compiledStr != "") compiledStr = compiledStr.slice(0, compiledStr.length-3) + " })";
    compiledStr = "state.subSeries.filter(x => { return " + compiledStr;

    return eval(compiledStr)
  },
  getSubSeriesBySingleId : (state) => (category, segment) => {
    if(
      (category == null || category == '') &&
      (segment == null || segment == '')
    ) return state.subSeries

    var counter = 0;
    var compiledStr = "state.subSeries.filter(singleSubSeries => "

    if (category != null && category != ''){
      compiledStr += "singleSubSeries.category == category &&"
      counter++;
    }

    if (segment != null && segment != ''){
      compiledStr += "singleSubSeries.segment == segment &&"
      counter++;
    }

    if(counter != 0) compiledStr = compiledStr.slice(0, compiledStr.length-3) + " )";

    return eval(compiledStr);
  },

  //Type
  getType : (state) => (category, segment, subSeries) => {
    if(
      (category == null || category.length == 0) &&
      (segment == null || segment.length == 0) &&
      (subSeries == null || subSeries.length == 0)
    ) return state.type

    var counter = 0;
    var categories = []
    var segments = []
    var subSerieses = []
    var compiledStr = "state.type.filter((singleType) => { return "

    if (category != null && category.length > 0){
      categories = category.map(a => a.category)
      compiledStr += "categories.indexOf(singleType.category) !== -1 &&"
      counter++;
    }

    if(segment != null && segment.length > 0){
      segments = segment.map(a => a.segment)
      compiledStr += "segments.indexOf(singleType.segment) !== -1 &&"
      counter++;
    }

    if(subSeries != null && subSeries.length > 0){
      subSerieses = subSeries.map(a => a.subseries)
      compiledStr += "subSerieses.indexOf(singleType.subseries) !== -1 &&"
      counter++;
    }

    if(counter != 0) compiledStr = compiledStr.slice(0, compiledStr.length-3) + " })";

    return eval(compiledStr)
  },
  getSimpleType : (state) => (category, segment, subSeries) => {
    if(
      (category == null || (typeof category != 'string' && category.length == 0)) &&
      (segment == null || (typeof segment != 'string' && segment.length == 0)) &&
      (subSeries == null || (typeof subSeries != 'string' && subSeries.length == 0))
    ) return state.type

    var categories = []
    var segments = []
    var subSerieses = []
    var compiledStr = ""

    //Array of 'category' strings or a string of 'category'
    if(category != null && (typeof category == 'string' || category.length > 0)){
      categories = typeof category == 'string' ? [category] : category
      compiledStr += "categories.indexOf(x.category) !== -1 &&"
    }

    //Array of 'segment' strings or a string of 'segment'
    if(segment != null && (typeof segment == 'string' || segment.length > 0)){
      segments = typeof segment == 'string' ? [segment] : segment
      compiledStr += "segments.indexOf(x.segment) !== -1 &&"
    }

    //Array of 'subSeries' strings or a string of 'subSeries'
    if(subSeries != null && (typeof subSeries == 'string' || subSeries.length > 0)){
      subSerieses = typeof subSeries == 'string' ? [subSeries] : subSeries
      compiledStr += "subSerieses.indexOf(x.subSeries) !== -1 &&"
    }

    if(compiledStr != "") compiledStr = compiledStr.slice(0, compiledStr.length-3) + " })";
    compiledStr = "state.type.filter(x => { return " + compiledStr;

    return eval(compiledStr)
  },
  getTypeBySingleId : (state) => (category, segment, subSeries) => {
    if(
      (category == null || category == '') &&
      (segment == null || segment == '') &&
      (subSeries == null || subSeries == '')
    ) return state.type

    var counter = 0;
    var compiledStr = "state.type.filter(singleType => "

    if (category != null && category != ''){
      compiledStr += "singleType.category == category &&"
      counter++;
    }

    if (segment != null && segment != ''){
      compiledStr += "singleType.segment == segment &&"
      counter++;
    }

    if (subSeries != null && subSeries != ''){
      compiledStr += "singleType.subSeries == subSeries &&"
      counter++;
    }

    if(counter != 0) compiledStr = compiledStr.slice(0, compiledStr.length-3) + " )";

    return eval(compiledStr);
  },

  //Code Market
  getCodeMarket : (state) => (category, segment, subSeries, type) => {
    if(
      (category == null || category.length == 0) &&
      (segment == null || segment.length == 0) &&
      (subSeries == null || subSeries.length == 0) &&
      (type == null || type.length == 0)
    ) return state.codeMarket

    var counter = 0;
    var categories = []
    var segments = []
    var subSerieses = []
    var types = []
    var compiledStr = "state.codeMarket.filter((singleCodeMarket) => { return "

    if (category != null && category.length > 0){
      categories = category.map(a => a.category)
      compiledStr += "categories.indexOf(singleCodeMarket.category) !== -1 &&"
      counter++;
    }

    if(segment != null && segment.length > 0){
      segments = segment.map(a => a.segment)
      compiledStr += "segments.indexOf(singleCodeMarket.segment) !== -1 &&"
      counter++;
    }

    if(subSeries != null && subSeries.length > 0){
      subSerieses = subSeries.map(a => a.subseries)
      compiledStr += "subSerieses.indexOf(singleCodeMarket.subseries) !== -1 &&"
      counter++;
    }

    if(type != null && type.length > 0){
      types = type.map(a => a.type)
      compiledStr += "types.indexOf(singleCodeMarket.type) !== -1 &&"
      counter++;
    }

    if(counter != 0) compiledStr = compiledStr.slice(0, compiledStr.length-3) + " })";

    return eval(compiledStr)
  },
  getSimpleCodeMarket : (state) => (category, segment, subSeries, type) => {
    if(
      (category == null || (typeof category != 'string' && category.length == 0)) &&
      (segment == null || (typeof segment != 'string' && segment.length == 0)) &&
      (subSeries == null || (typeof subSeries != 'string' && subSeries.length == 0)) &&
      (type == null || (typeof type != 'string' && type.length == 0))
    ) return state.codeMarket

    var categories = []
    var segments = []
    var subSerieses = []
    var types = []
    var compiledStr = ""

    //Array of 'category' strings or a string of 'category'
    if(category != null && (typeof category == 'string' || category.length > 0)){
      categories = typeof category == 'string' ? [category] : category
      compiledStr += "categories.indexOf(x.category) !== -1 &&"
    }

    //Array of 'segment' strings or a string of 'segment'
    if(segment != null && (typeof segment == 'string' || segment.length > 0)){
      segments = typeof segment == 'string' ? [segment] : segment
      compiledStr += "segments.indexOf(x.segment) !== -1 &&"
    }

    //Array of 'subSeries' strings or a string of 'subSeries'
    if(subSeries != null && (typeof subSeries == 'string' || subSeries.length > 0)){
      subSerieses = typeof subSeries == 'string' ? [subSeries] : subSeries
      compiledStr += "subSerieses.indexOf(x.subSeries) !== -1 &&"
    }

    //Array of 'type' strings or a string of 'type'
    if(type != null && (typeof type == 'string' || type.length > 0)){
      types = typeof type == 'string' ? [type] : type
      compiledStr += "types.indexOf(x.type) !== -1 &&"
    }

    if(compiledStr != "") compiledStr = compiledStr.slice(0, compiledStr.length-3) + " })";
    compiledStr = "state.codeMarket.filter(x => { return " + compiledStr;

    return eval(compiledStr)
  },
  getCodeMarketBySingleId : (state) => (category, segment, subSeries, type) => {
    if(
      (category == null || category == '') &&
      (segment == null || segment == '') &&
      (subSeries == null || subSeries == '') &&
      (type == null || type == '')
    ) return state.codeMarket

    var counter = 0;
    var compiledStr = "state.codeMarket.filter(singleCodeMarket => "

    if (category != null && category != ''){
      compiledStr += "singleCodeMarket.category == category &&"
      counter++;
    }

    if (segment != null && segment != ''){
      compiledStr += "singleCodeMarket.segment == segment &&"
      counter++;
    }

    if (subSeries != null && subSeries != ''){
      compiledStr += "singleCodeMarket.subSeries == subSeries &&"
      counter++;
    }

    if (type != null && type != ''){
      compiledStr += "singleCodeMarket.type == type &&"
      counter++;
    }

    if(counter != 0) compiledStr = compiledStr.slice(0, compiledStr.length-3) + " )";

    return eval(compiledStr);
  },

  getMonth : (state) => {
    return state.month
  },
  getYear : (state) => {
    return state.year
  },
  getColor : (state) => {
    return state.color
  },
  getTransporter : (state) => {
    return state.transporter
  },
  getFilterOptions : (state) => {
    const filterOptions = {
      mainDealer: state.mainDealer,
      gudang: state.gudang,
      karesidenan: state.karesidenan,
      city: state.city,
      dealer: state.dealer,
      category: state.category,
      segment: state.segment,
      subSeries: state.subSeries,
      type: state.type,
      codeMarket: state.codeMarket,
      month: state.month,
      year: state.year,
      color: state.color,
      transporter: state.transporter
    }
    return filterOptions
  }
}

const mutations = {
  mainDealerStatus (state, mainDealer) {
    if(mainDealer){
      state.mainDealer = mainDealer;
    } else {
      state.mainDealer = null;
    }
  },
  gudangStatus (state, gudang) {
    if(gudang){
      state.gudang = gudang;
    } else {
      state.gudang = null;
    }
  },
  karesidenanStatus (state, karesidenan) {
    if(karesidenan){
      state.karesidenan = karesidenan;
    } else {
      state.karesidenan = null;
    }
  },
  cityStatus (state, city) {
    if(city){
      state.city = city;
    } else {
      state.city = null;
    }
  },
  dealerStatus (state, dealer) {
    if(dealer){
      state.dealer = dealer;
    } else {
      state.dealer = null;
    }
  },
  categoryStatus (state, category) {
    if(category){
      state.category = category;
    } else {
      state.category = null;
    }
  },
  segmentStatus (state, segment) {
    if(segment){
      state.segment = segment;
    } else {
      state.segment = null;
    }
  },
  subSeriesStatus (state, subSeries) {
    if(subSeries){
      state.subSeries = subSeries;
    } else {
      state.subSeries = null;
    }
  },
  typeStatus (state, type) {
    if(type){
      state.type = type;
    } else {
      state.type = null;
    }
  },
  codeMarketStatus (state, codeMarket) {
    if(codeMarket){
      state.codeMarket = codeMarket;
    } else {
      state.codeMarket = null;
    }
  },
  monthStatus (state, month){
      if(month){
        state.month = month;
      } else {
        state.month = null;
      }
  },
  yearStatus (state, year) {
    if(year){
      state.year = year;
    } else {
      state.year = null;
    }
  },
  colorStatus (state, color) {
    if(color){
      state.color = color;
    } else {
      state.color = null;
    }
  },
  transporterStatus (state, transporter) {
    if(transporter){
      state.transporter = transporter;
    } else {
      state.transporter = null;
    }
  },
  filterOptionsStatus (state, filterOptions){
    if(filterOptions){
      state.mainDealer = (filterOptions['mainDealer'] != null) ? filterOptions['mainDealer'] : null;
      state.gudang = (filterOptions['gudang'] != null) ? filterOptions['gudang'] : null;
      state.karesidenan = (filterOptions['karesidenan'] != null) ? filterOptions['karesidenan'] : null;
      state.city = (filterOptions['city'] != null) ? filterOptions['city'] : null;
      state.dealer = (filterOptions['dealer'] != null) ? filterOptions['dealer'] : null;
      state.category = (filterOptions['category'] != null) ? filterOptions['category'] : null;
      state.segment = (filterOptions['segment'] != null) ? filterOptions['segment'] : null;
      state.subSeries = (filterOptions['subSeries'] != null) ? filterOptions['subSeries'] : null;
      state.type = (filterOptions['type'] != null) ? filterOptions['type'] : null;
      state.codeMarket = (filterOptions['codeMarket'] != null) ? filterOptions['codeMarket'] : null;
      state.month = (filterOptions['month'] != null) ? filterOptions['month'] : null;
      state.year = (filterOptions['year'] != null) ? filterOptions['year'] : null;
      state.color = (filterOptions['color'] != null) ? filterOptions['color'] : null;
      state.transporter = (filterOptions['transporter'] != null) ? filterOptions['transporter'] : null;
    } else {
      state.mainDealer = null;
      state.gudang = null;
      state.karesidenan = null;
      state.city = null;
      state.dealer = null;
      state.category = null;
      state.segment = null;
      state.subSeries = null;
      state.type = null;
      state.codeMarket = null;
      state.month = null;
      state.year = null;
      state.color = null;
      state.transporter = null;
    }
  }
}

const actions = {
  setMainDealer ({ commit }, mainDealer){
    commit('mainDealerStatus', mainDealer);
  },
  setGudang ({ commit }, gudang){
    commit('gudangStatus', gudang);
  },
  setKaresidenan ({ commit }, karesidenan){
    commit('karesidenanStatus', karesidenan);
  },
  setCity ({ commit }, city){
    commit('cityStatus', city);
  },
  setDealer ({ commit }, dealer){
    commit('dealerStatus', dealer);
  },
  setCategory ({ commit }, category){
    commit('categoryStatus', category);
  },
  setSegment ({ commit }, segment){
    commit('segmentStatus', segment);
  },
  setSubSeries ({ commit }, subSeries){
    commit('subSeriesStatus', subSeries);
  },
  setType ({ commit }, type){
    commit('typeStatus', type);
  },
  setCodeMarket ({ commit }, codeMarket){
    commit('codeMarketStatus', codeMarket);
  },
  setMonth ({ commit }, month){
    commit('monthStatus', month);
  },
  setYear ({ commit }, year){
    commit('yearStatus', year);
  },
  setColor ({ commit }, color){
    commit('colorStatus', color);
  },
  setFilterOptions ({ commit }, filterOptions){
    commit('filterOptionsStatus', filterOptions);
  },
  setTransporter ({ commit }, transporter){
    commit('transporterStatus', transporter);
  },
}

export default{
  state,
  getters,
  mutations,
  actions
}